<template>
  <div class="tradeItem-w">
    <div class="head">
      <div class="picture_w" :style="randomRgb">
        <el-image
          class="picture"
          :src="
            data.cover
              ? data.cover + '!283'
              : require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')
          "
          alt=""
          lazy
        />
      </div>
      <el-tooltip placement="bottom">
        <div slot="content">{{ data.title }}</div>
        <h3 class="title text_ellipsis c_1A1A1A">{{ data.title }}</h3>
      </el-tooltip>
    </div>
    <div class="main">
      <div class="desc_item">
        <span class="key_label white_s_nowrap fz14 c_808080"> 价格： </span>
        <div class="text_ellipsis c_CF3342">
          <span class="fz15 font_w_bold">
            <span v-if="data.price != '面议'">￥{{ numTurnText02(numberPart) }}{{ unitPart }}</span><span v-else>面议</span></span
          >
        </div>
      </div>

      <div class="desc_item">
        <span class="key_label white_s_nowrap fz14 c_808080">
          面积/数量：
        </span>
        <div class="text_ellipsis">
          <span class="fz14 c_808080"> {{ data.quantity }}</span>
        </div>
      </div>

      <div class="desc_item">
        <span class="key_label white_s_nowrap fz14 c_808080"> 转出期限： </span>
        <div class="text_ellipsis">
          <span class="fz14 c_808080">
            {{ data.deadline
            }}{{ deadlineUnitConversion(data.deadlineUnit) }}</span
          >
        </div>
      </div>

      <!-- 区域，状态 -->
      <div
        class="
          optional
          d_flex
          justify_content_sb
          align_item_c
          fz14
          c_808080
          ps_flag
        "
      >
        <div class="d_flex align_item_c">
          <i class="el-icon-location-outline fz18" /><span
            class="location_name fz14"
            >{{ data.regionName }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { numTurnText02 } from '@/utils'
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      randomRgb: {
        backgroundColor:
          "rgb(" +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          "," +
          Math.floor(Math.random() * 130 + 110) +
          ")",
      },
      numberPart:'',
      unitPart:''
    };
  },
  mounted() {
    if(this.data.price != '面议'){
      const [numberPart, unitPart] = this.data.price.split(/(?<=\d)(?=[^\d])/);
      this.numberPart = numberPart;
      this.unitPart = unitPart;
    }

  },
  computed: {
    ...mapGetters(["deadlineUnitKey"]),
    // 格式化金额（中文）
    numTurnText02: function() {
      return function(num) {
        return numTurnText02(num)
      }
    },
  },
  methods: {
    deadlineUnitConversion(param) {
      return this.deadlineUnitKey[param];
    },
  },
};
</script>

<style lang="scss" scoped>
.tradeItem-w {
  display: flex;
  flex-direction: column;
  width: 285px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  &:nth-child(4n) {
    margin: 0 0 20px 0;
  }
  &:hover {
    cursor: pointer;
  }
  .head {
    .picture_w {
      position: relative;
      height: 150px;
    }
    .picture {
      ::v-deep img {
        position: static; // 兼容ie
        display: block;
        width: 283px;
        height: 150px;
        transform: none; // 兼容ie
      }
    }
    .title {
      padding: 15px;
    }
  }
  .main {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 15px;
    border-top: 1px solid #e6e6e6;
    .desc_item {
      display: flex;
      align-items: center;
      margin: 0 0 15px 0;
      .time {
        margin-left: 10px;
      }
    }
    .ps_flag {
      position: relative;
      left: -2px;
    }
    .key_label {
      margin-right: 8px;
    }
    .state {
      height: 26px;
      line-height: 26px;
      margin-right: -16px;
      padding: 0 14px;
    }
    .optional {
      margin-top: auto;
      .location_name {
        margin-left: 6px;
      }
    }
  }
  .bottom {
    margin-top: auto;
    border-top: 1px solid #e6e6e6;
    .data_count {
      margin: 10px 0;
      flex: 1;
      border-right: 1px solid #dbd5d5;
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
